export default "__VITE_ASSET__CxnU_UaS__"